package one.healthium.profile.navigation

import com.arkivanov.decompose.router.stack.ChildStack
import com.arkivanov.decompose.router.webhistory.WebNavigationOwner
import com.arkivanov.decompose.value.Value
import com.arkivanov.essenty.backhandler.BackHandlerOwner
import one.healthium.profile.navigation.food_history.FoodHistoryComponent
import one.healthium.profile.navigation.healthKit.HealthKitSettingsComponent
import one.healthium.profile.navigation.meal_plan_settings.MealPlanSettingsComponent
import one.healthium.profile.navigation.profile.ProfileComponent
import one.healthium.profile.navigation.settings.ProfileSettingsComponent
import one.healthium.profile.navigation.weight_history.WeightHistoryComponent
import one.healthium.settings.ui.menu.SettingsMenuComponent

interface ProfileMainComponent : BackHandlerOwner, WebNavigationOwner {
    val stack: Value<ChildStack<*, Child>>

    fun onBackClicked()

    sealed class Child {
        class ProfileChild(val component: ProfileComponent) : Child()
        class SettingsChild(val component: ProfileSettingsComponent) : Child()
        class SettingsMenu(val component: SettingsMenuComponent) : Child()
        class MealPlanSettings(val component: MealPlanSettingsComponent) : Child()
        class WeightHistory(val component: WeightHistoryComponent) : Child()
        class FoodHistory(val component: FoodHistoryComponent) : Child()
        class HealthKitConnect(val component: HealthKitSettingsComponent) : Child()
    }
}